<div class="container">
    <div class="tab-window">
        <h2>{{ call.description }}</h2>
    </div>
    <button class="close" (click)="onCloseChildWindow()" mat-raised-button color="primary">{{ "Close" | translate }}</button>
</div>
